function EmptyState({ title, description, action }) {
    return (
      <div className="rounded-3xl bg-white p-8 text-center shadow-sm ring-1 ring-slate-200">
        <div className="mx-auto max-w-md">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-slate-100">
            <div className="h-6 w-6 rounded-full border-2 border-slate-300" />
          </div>
  
          <h3 className="text-lg font-semibold tracking-tight text-slate-900">
            {title}
          </h3>
  
          {description && (
            <p className="mt-2 text-sm text-slate-600">{description}</p>
          )}
  
          {action ? <div className="mt-5">{action}</div> : null}
        </div>
      </div>
    );
  }
  
  export default EmptyState;